import cn from "@/v2-ui/utils/utils.cn"
import type { SidebarProps } from "@/v2-backoffice-client/components/sidebar"
import SidebarContent from "@/v2-backoffice-client/components/sidebar/SidebarContent"

export type PageSidebarProps = SidebarProps

function PageSidebar(props: PageSidebarProps) {
  const { className, ...sidebarProps } = props
  return (
    <SidebarContent
      className={cn("page-sidebar", className)}
      {...sidebarProps}
    />
  )
}

export default PageSidebar
